import { Badge } from "@freightsimple/ui-core/Display/Badge";

interface PreferredBrokerPillProps {
  preferredNorthbound: boolean;
  preferredSouthbound: boolean;
}
function BrokersPreferredBrokerPill(props: PreferredBrokerPillProps) {
  if (!props.preferredNorthbound && !props.preferredSouthbound) {
    return <></>;
  }

  if (props.preferredNorthbound && props.preferredSouthbound) {
    return <Badge label="Preferred: All Shipments" variant="warning" />;
  }

  if (props.preferredNorthbound && !props.preferredSouthbound) {
    return (
      <Badge label="Preferred: United States Pickups 🇺🇸" variant="warning" />
    );
  }

  if (!props.preferredNorthbound && props.preferredSouthbound) {
    return <Badge label="Preferred: Canada Pickups 🇨🇦" variant="warning" />;
  }

  throw new Error("Unhandled broker pill case");
}
export default BrokersPreferredBrokerPill;
